<template>
    <div class="TQ_center">

        <!-- tabs-->
        <div class="TQ_padding_8px TQ_direction_ltr TQ_margin_top_16px">
            <div v-for="(tab_s, index_n) in outerTabs_as"
                 :class="{
                    'TQ_borderRadius_left' : index_n === 0,
                    'TQ_borderRadius_right': index_n === outerTabs_as.length-1,
                    'TQ_bg_purple_dark': outerTabs_selectedTabIndex_n === index_n,
                 }"
                 @click="m_outerTab_clickTab_f(index_n)"
                 class="TQ_inline TQ_padding_12px TQ_box_shadow TQ_bg_white TQ_clickable TQ_text_20px">
                {{tab_s}}
            </div>
        </div>

        <!-- 0) Reviews Reports -->
        <div v-if="outerTabs_selectedTabIndex_n === 0">
            <tq-card margin="16px" padding="16px">

                <div class="TQ_borderRadius TQ_padding_8px TQ_bg_gray4">
                    <tq-table
                        class="TQ_padding_8px TQ_bg_white TQ_margin_8px TQ_selectable "
                        :rows="server_reportsReviews_ac"
                        :system-lang-code="store_system_langCode_ve.val"
                        :display-search="true"
                        p_td-classes_s="TQ_padding_8px"
                        :columns="[
                            {label : ass_strings.oneWord_id[store_system_langCode_ve.val], class_s: () => {return 'TQ_text_capitalize'}, field(reportReview_c){return reportReview_c.rr_reportReview_uid}},
                            {label : ass_strings.twoWords_questId[store_system_langCode_ve.val], class_s: () => {return 'TQ_text_capitalize'}, field(reportReview_c){return reportReview_c.rr_questId_uid}},
                            {label : ass_strings.twoWords_userId[store_system_langCode_ve.val], class_s: () => {return 'TQ_text_capitalize'}, field(reportReview_c){return reportReview_c.rr_reportUserId_uid}},
                            {label : ass_strings.oneWord_text[store_system_langCode_ve.val], class_s: () => {return 'TQ_text_capitalize'}, field(reportReview_c){return reportReview_c.rr_text_s}},
                        ]"
                        :p_actions_ao="[
                           { display : (qt) => {return true},   label_byLangCode : ass_strings.oneWord_edit, popupText_byLangCode: null, action_f : m_editReview_f,  class : 'TQ_bg_gold'   },
                           { display : (qt) => {return true},   label_byLangCode : ass_strings.oneWord_close, popupText_byLangCode: null, action_f : m_updateReviewStatus_f,  class : 'TQ_bg_red'   },
                        ]"
                    />
                </div>

                <hr>

                <div>

                    <div class="TQ_inline TQ_bg_green TQ_padding_8px TQ_box_shadow TQ_margin_8px TQ_borderRadius TQ_text_20px TQ_clickable"
                         @click="m_getAllReviewsReports_f">
                        {{ass_strings.oneWord_update[store_system_langCode_ve.val]}}
                    </div>
                </div>

            </tq-card>
            <br>

            <tq-card margin="16px" padding="16px" v-if="server_selectedReview_c" class="TQ_maxWidth_700px TQ_width_100p">

                <!-- basic info -->
                <div>
                    <div>
                        <div>
                            review id
                        </div>
                        <div>
                            {{server_selectedReview_c.qr_reviewerId_uid}}
                        </div>
                    </div>

                    <div>
                        <div>
                            quest id
                        </div>
                        {{server_selectedReview_c.qr_questId_uid}}
                    </div>
                </div>
                <hr>

                <!-- overall rating and diff level-->
                <div>
                    <div>
                        <div>
                            overall rating
                        </div>
                        <input max="5" min="1" type="number" v-model.number="server_selectedReview_c.qr_overallRating_n"/>
                    </div>

                    <div>
                        <div>
                            Diff level
                        </div>
                        <input max="5" min="1" type="number" v-model.number="server_selectedReview_c.qr_difficulty_n"/>
                    </div>
                </div>
                <hr>

                <!-- public and private  -->
                <div>
                    <div>
                        <div>
                            public review
                        </div>
                        <tq-textarea
                            pb_uid_s="qr_publicFeedback_s"
                            pb_textarea-class_s="TQ_padding_4px"
                            :pb_init-text_s="server_selectedReview_c.qr_publicFeedback_s"
                            :pb_max-length_n="500"
                            :pb_placeholder_s="ass_strings.oneWord_text[store_system_langCode_ve.val]"
                            :pb_rows_n="4"
                            :pe_change-text_s="(text_s) => {server_selectedReview_c.qr_publicFeedback_s = text_s}"
                        />
                    </div>
                    <div>
                        <div>
                            Private review
                        </div>
                        <tq-textarea
                            pb_uid_s="qr_publicFeedback_s"
                            pb_textarea-class_s="TQ_padding_4px"
                            :pb_init-text_s="server_selectedReview_c.qr_privateFeedback_s"
                            :pb_max-length_n="500"
                            :pb_placeholder_s="ass_strings.oneWord_text[store_system_langCode_ve.val]"
                            :pb_rows_n="4"
                            :pe_change-text_s="(text_s) => {server_selectedReview_c.qr_privateFeedback_s = text_s}"
                        />
                    </div>
                </div>

                <!-- btn -->
                <div class="TQ_inline TQ_bg_green TQ_padding_8px TQ_box_shadow TQ_margin_8px TQ_borderRadius TQ_text_20px TQ_clickable"
                     @click="m_updateReview_f">
                    Update
                </div>

            </tq-card>
        </div>

        <!-- 1) monthly payments -->
        <div v-else-if="outerTabs_selectedTabIndex_n === 1">

            <!-- table -->
            <div class="TQ_inline TQ_padding_8px">

                <!-- choose date -->
                <div class="TQ_grid_col_1frAuto">

                    <!-- date and refresh-->
                    <div class="TQ_align_initial TQ_grid_verticalCenter">
                        <input v-model="selectedMonth_yyyy_mm_s" type="month" class="TQ_padding_8px TQ_margin_8px TQ_verticalAlignMiddle TQ_clickable"/>

                        <div @click="m_monthlyPayment_getReport_f"
                             class="TQ_bg_green TQ_clickable TQ_box_shadow TQ_padding_8px TQ_inline TQ_borderRadius TQ_text_20px TQ_verticalAlignMiddle">
                            Get Reports
                        </div>

                    </div>

                    <!-- update report -->
                    <tq-loader-container :p_show-loader_b="showUpdateReportBtn_b" class="TQ_inline TQ_grid_verticalCenter ">
                        <tq-btn-approve
                            class="TQ_bg_gold TQ_padding_8px TQ_inline TQ_borderRadius TQ_clickable TQ_text_20px TQ_textColor_white"
                            :approve-cb="m_monthlyPayment_updateAllReports_f"
                            :popup-text="ass_strings.oneWord_notice"
                            :system-lang-code="store_system_langCode_ve.val">
                            Run Update Reports
                        </tq-btn-approve>

                    </tq-loader-container>

                </div>

                <!-- table -->
                <div class="TQ_center">
                    <table class="TQ_scrollable TQ_maxWidth_100p">
                        <tr>
                            <th>creatorId</th>
                            <th>email Title</th>

                            <th>total created Tickets</th>
                            <th>charged Payment Status_e</th>

                            <th>total store Incomes</th>
                            <th>send Payment Status</th>

                            <th>total Incomes</th>


                        </tr>

                        <tr v-for="creatorMonthlyPaymentSummary_c in server_creatorMonthlyPaymentSummary_ac">
                            <!-- creatorId-->
                            <td>{{creatorMonthlyPaymentSummary_c.cmps_creatorId_uid}}</td>

                            <!-- emailTitle-->
                            <td>{{creatorMonthlyPaymentSummary_c.cmps_emailTitle_s}}</td>

                            <!-- created tickets -->
                            <td>
                                {{creatorMonthlyPaymentSummary_c.cmps_createdTicketsNum_n}}
                                ({{ m_monthlyPayment_ticketsCost_fs(creatorMonthlyPaymentSummary_c.cmps_createdTicketsNum_n)}})
                            </td>

                            <!-- charge status-->
                            <td :class="[creatorMonthlyPaymentSummary_c.cmps_chargePaymentStatus_e === enum_creatorChargePaymentStatus.didntCharge && creatorMonthlyPaymentSummary_c.cmps_createdTicketsNum_n > 10 && 'TQ_bg_red',
                                        creatorMonthlyPaymentSummary_c.cmps_chargePaymentStatus_e === enum_creatorChargePaymentStatus.charged && 'TQ_bg_green']"  >
                                <div v-if="creatorMonthlyPaymentSummary_c.cmps_createdTicketsNum_n <= 10 || notPayingUsersId_uid_b[creatorMonthlyPaymentSummary_c.cmps_creatorId_uid]">
                                    -
                                </div>
                                <div v-else>
                                    {{creatorMonthlyPaymentSummary_c.cmps_chargePaymentStatus_e}}
                                    <a v-if="creatorMonthlyPaymentSummary_c.cmps_chargePaymentReceiptUrl_s" :href="creatorMonthlyPaymentSummary_c.cmps_chargePaymentReceiptUrl_s">
                                        receipt
                                    </a>
                                </div>

                            </td>

                            <!-- store -->
                            <td>
                                <div class="TQ_inline" v-for="(cost_c, index_n) in creatorMonthlyPaymentSummary_c.cmps_totalStoreIncomes_byCurrency_c">
                                    <span v-if="index_n>0">, </span>{{ format_cost_s(cost_c) }}({{ m_monthlyPayment_formatCost_20p_fs(cost_c) }})
                                </div>

                            </td>

                            <!-- send payment status-->
                            <td :class="[creatorMonthlyPaymentSummary_c.cmps_sendPaymentStatus_e === enum_creatorSendPaymentStatus.didntSend && obj_size_fn(creatorMonthlyPaymentSummary_c.cmps_totalStoreIncomes_byCurrency_c) > 0  && 'TQ_bg_red',
                                creatorMonthlyPaymentSummary_c.cmps_sendPaymentStatus_e === enum_creatorSendPaymentStatus.receivedReceipt && 'TQ_bg_green']">

                                <div v-if="obj_size_fn(creatorMonthlyPaymentSummary_c.cmps_totalStoreIncomes_byCurrency_c) === 0 || notPayingUsersId_uid_b[creatorMonthlyPaymentSummary_c.cmps_creatorId_uid]">
                                    -
                                </div>
                                <div v-else>
                                    {{creatorMonthlyPaymentSummary_c.cmps_sendPaymentStatus_e}}
                                    <a v-if="creatorMonthlyPaymentSummary_c.cmps_sendPaymentReceiptUrl_s" :href="creatorMonthlyPaymentSummary_c.cmps_sendPaymentReceiptUrl_s">
                                        receipt
                                    </a>
                                </div>

                            </td>


                            <!-- total income-->
                            <td>
                                {{format_cost_s(creatorTotalIncome_byUid_c[creatorMonthlyPaymentSummary_c.cmps_creatorId_uid]) }}
                            </td>

                            <!-- open btn -->
                            <td>
                                <div class="TQ_bg_gold TQ_clickable TQ_box_shadow TQ_borderRadius TQ_inline TQ_padding_4px"
                                     @click="selectedCreatorMonthlyPaymentSummary_c = creatorMonthlyPaymentSummary_c">
                                    Open
                                </div>

                            </td>

                        </tr>

                        <tr class="TQ_align_initial TQ_bg_gray4 TQ_text_20px" v-if="server_creatorMonthlyPaymentSummary_ac.length > 0">
                            <td colspan="8" class="TQ_padding_8px">
                                Total:
                            </td>
                        </tr>
                        <tr class="TQ_bg_gold_lite" v-if="server_creatorMonthlyPaymentSummary_ac.length > 0">
                            <td></td>
                            <td></td>

                            <td>
                                {{sumCreatedTickets_n}}
                                ({{ sumCreatedCost_n}}$)
                            </td>
                            <td></td>

                            <td>
                                <div class="TQ_inline" v-for="(cost_c, index_n) in sumStoreIncomes_byCurrency_c">
                                    <span v-if="index_n>0">, </span>{{format_cost_s(cost_c)}} ({{ m_monthlyPayment_formatCost_20p_fs(cost_c)}})
                                </div>
                            </td>
                            <td></td>

                            <td>{{ format_cost_s(allCreatorTotalIncome_c)}}</td>

                            <td></td>
                        </tr>
                    </table>
                </div>
            </div>

            <!-- edit report-->
            <div class="TQ_border TQ_padding_8px TQ_bg_white TQ_margin_8px" v-if="selectedCreatorMonthlyPaymentSummary_c">

                <!-- title-->
                <div class="TQ_padding_8px TQ_bg_purple_dark TQ_text_24px">
                    <div v-html="selectedCreatorMonthlyPaymentSummary_c.cmps_emailTitle_s"></div>
                </div>

                <!-- send payment -->
                <div>
                    <div class="TQ_inline">
                        <div>Send Payment </div>
                        <tq-dropdown class="TQ_bg_white TQ_width_200px " :style-select="true">

                            <div slot="select" class="TQ_padding_4px">
                                {{ selectedCreatorMonthlyPaymentSummary_c.cmps_sendPaymentStatus_e }}
                            </div>

                            <div    slot="options"
                                    @click="selectedCreatorMonthlyPaymentSummary_c.cmps_sendPaymentStatus_e = option_e"
                                    v-for="option_e in enum_creatorSendPaymentStatus">
                                {{option_e}}
                            </div>
                        </tq-dropdown>
                    </div>

                    <div class="TQ_padding_2px TQ_inline"></div>

                    <!-- send payment receipt-->
                    <div class="TQ_inline">
                        <div>Receipt Url </div>
                        <input class="TQ_padding_8px" v-model="selectedCreatorMonthlyPaymentSummary_c.cmps_sendPaymentReceiptUrl_s">
                    </div>

                </div>

                <!-- Charge payment -->
                <div>
                    <div class="TQ_inline">
                        <div>Charge Payment </div>
                        <tq-dropdown class="TQ_bg_white TQ_width_200px " :style-select="true">

                            <div slot="select" class="TQ_padding_4px">
                                {{ selectedCreatorMonthlyPaymentSummary_c.cmps_chargePaymentStatus_e }}
                            </div>

                            <div    slot="options"
                                    @click="selectedCreatorMonthlyPaymentSummary_c.cmps_chargePaymentStatus_e = option_e"
                                    v-for="option_e in enum_creatorChargePaymentStatus">
                                {{option_e}}
                            </div>
                        </tq-dropdown>
                    </div>

                    <div class="TQ_padding_2px TQ_inline"></div>

                    <!-- send payment receipt-->
                    <div class="TQ_inline">
                        <div>Receipt Url </div>
                        <input class="TQ_padding_8px" v-model="selectedCreatorMonthlyPaymentSummary_c.cmps_chargePaymentReceiptUrl_s">
                    </div>

                </div>

                <!-- actions -->
                <div class="TQ_padding_8px">


                    <!-- update -->
                    <tq-btn-approve
                        class="TQ_bg_gold TQ_padding_8px TQ_inline TQ_borderRadius TQ_clickable TQ_margin_8px"
                        :approve-cb="m_monthlyPayment_updateReport_f"
                        :popup-text="ass_strings.oneWord_update"
                        :system-lang-code="store_system_langCode_ve.val">
                        Update
                    </tq-btn-approve>

                    <!-- charge -->
                    <tq-btn-approve
                        v-if="enum_creatorChargePaymentStatus.didntCharge === selectedCreatorMonthlyPaymentSummary_c.cmps_chargePaymentStatus_e"
                        class="TQ_bg_red TQ_padding_8px TQ_inline TQ_borderRadius TQ_clickable TQ_margin_8px"
                        :approve-cb="m_monthlyPayment_chargeReport_f"
                        :popup-text="ass_strings.oneWord_charge"
                        :system-lang-code="store_system_langCode_ve.val">
                        Charge Tickets
                    </tq-btn-approve>

                    <!-- send email -->
                    <tq-btn-approve
                        class="TQ_bg_green TQ_padding_8px TQ_inline TQ_borderRadius TQ_clickable TQ_margin_8px"
                        :approve-cb="m_monthlyPayment_emailReport_f"
                        :popup-text="ass_strings.oneWord_send"
                        :system-lang-code="store_system_langCode_ve.val">
                        Email Report
                    </tq-btn-approve>

                </div>

                <!-- full report -->
                <hr>
                <div class="TQ_padding_8px TQ_maxWidth_1200px TQ_inline">
                    <div v-html="co_formatMonthSum_s"></div>
                </div>

            </div>


        </div>

        <!-- 2) users summary-->
        <div v-else-if="outerTabs_selectedTabIndex_n === 2" class="TQ_padding_8px">


            <div class="TQ_inline">

                <div>
                    Start Date
                </div>
                <input v-model="startMonth_yyyy_mm_s" type="month" class="TQ_padding_8px TQ_margin_8px TQ_verticalAlignMiddle TQ_clickable"/>

            </div>

            <div class="TQ_inline">
                <div >
                    end date
                </div>
                <input v-model="endMonth_yyyy_mm_s" type="month" class="TQ_padding_8px TQ_margin_8px TQ_verticalAlignMiddle TQ_clickable"/>

            </div>

            <div class="TQ_inline">
                <div @click="m_userReport_getReport_f"
                     class="TQ_bg_green TQ_clickable TQ_box_shadow TQ_padding_8px TQ_inline TQ_borderRadius TQ_text_20px TQ_verticalAlignMiddle">
                    Get Reports
                </div>


            </div>


            <div>

                <div v-for="(userData_c, creatorId_uid) in creatorData_byUserIds_c"
                     @click="$set(selectedCreator_byUid_b, creatorId_uid, !selectedCreator_byUid_b[creatorId_uid])"
                     :class="selectedCreator_byUid_b[creatorId_uid] && 'TQ_bg_purple_lite'"
                     class="TQ_inline TQ_padding_8px TQ_borderBox TQ_box_shadow TQ_borderRadius TQ_bg_white TQ_margin_2px TQ_clickable">
                    {{userData_c.ud_name_s}}
                </div>

            </div>




            <!-- chart last year per user-->
            <div v-if="obj_size_fn(selectedCreator_byUid_b) > 0">

                <div>
                    <div class="TQ_text_20px TQ_bg_white TQ_box_shadow2 TQ_borderRadius TQ_margin_8px TQ_inline TQ_padding_8px TQ_border_g_2px">
                        <div>
                            Total TQ Store Income
                        </div>
                        <div class="TQ_text_24px ">
                            {{co_totalStoreIncome_s}}
                        </div>
                    </div>

                    <div class="TQ_text_20px TQ_bg_white TQ_box_shadow2 TQ_borderRadius TQ_margin_8px TQ_inline TQ_padding_8px TQ_border_green_2px ">
                        <div>
                            Total Created Tickets
                        </div>
                        <div class="TQ_text_24px">
                            {{co_totalCreatedTickets_s}}
                        </div>
                    </div>

                </div>

                <tq-chart
                    class="TQ_margin_8px TQ_bg_white TQ_padding_8px TQ_borderRadius"
                    :datasets="co_chartData_createdTickets_ao"
                    type="line"
                    :height="80"
                    :p_x-axes_ao="[{
                        type: 'time',
                        time: {
                          unit: 'month'
                        }
                    }]"
                    :p_y-axes_ao="[{
                            id: 'CreatedTickets',
                            scaleLabel: {
                                labelString: 'CreatedTickets'
                            },
                            ticks: {
                                min: 0,
                            }
                        }]"
                />

                <tq-chart
                    class="TQ_margin_8px TQ_bg_white TQ_padding_8px TQ_borderRadius "
                    :datasets="co_chartData_storeSelle_ao"
                    type="line"
                    :height="80"
                    :p_x-axes_ao="[{
                        type: 'time',
                        time: {
                          unit: 'month'
                        }
                    }]"
                    :p_y-axes_ao="[{
                            id: 'CreatedTickets',
                            scaleLabel: {
                                labelString: 'CreatedTickets'
                            },
                            ticks: {
                                min: 0,
                            }
                        }]"
                />

            </div>

        </div>

    </div>
</template>

<script>

    import {store_getStateValue_vo, store_var} from "../../store";
    import TqTable from "../../components/basic2/TqTable";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {
        enum_costCurrency_n,
        enum_creatorChargePaymentStatus,
        enum_creatorSendPaymentStatus,
        enum_reportReviewStatus_e
    } from "../../../functions/src/shareCode/Share_S_Enum";
    import TqCard from "../../components/basic/TqCard";
    import {
        server_admin_chargeCreatorMonthlyReport_fp, server_admin_updateAllReports_fp,
        server_getUserQuestReview_fp, server_sendMail_fp,
        server_submitQuestTqReview_f,
        serverPre_reportReview_getOnce_f, serverPre_reportReview_update_f
    } from "../../scripts/Server/S_ServerPre";
    import {obj_size_fn, obj_toArray_fo} from "../../../functions/src/shareCode/Share_S_Obj";
    import TqTextareaAutosize from "../../components/basic/TqTextareaAutosize";
    import TqTextarea from "../../components/basic/TqTextarea";
    import {notification_notify2} from "../../scripts/S_Notification";
    import {
        serverBig_admin_creatorsMonthlyPaymentSummary_getAll_f,
        serverBig_admin_creatorsMonthlyPaymentSummary_update_f,
    } from "@/scripts/Server/S_ServerFirestore";
    import {format_cost_s, format_date_YYYY_MM_fs} from "../../../functions/src/shareCode/Share_S_Format";
    import TqPopup from "@/components/basic/TqPopup";
    import TqDropdown from "@/components/basic/TqDropdown";
    import {FB_Cost, FB_QuestTicket, FB_SendEmail} from "../../../functions/src/shareCode/Share_S_Classes";
    import TqBtnApprove from "@/components/basic2/TqBtnApprove";
    import TqLoaderContainer from "@/components/basic/TqLoaderContainer";
    import {helper_getDirectionByLangCode_fe} from "@/scripts/S_Helper";
    import {email_bodyWrapper_fs} from "../../../functions/src/server/Helpers/Fun_S_EamilsFormater";
    import TqChart from "@/components/complex/TqChart";
    import {serverAuth_getOtherUserData_f} from "@/scripts/Server/S_ServerAuth";

    export default {
        name: "v_Admin_Reviews_Reports",
        components: {
            TqChart,
            TqLoaderContainer,
            TqBtnApprove, TqDropdown, TqPopup, TqTextarea, TqTextareaAutosize, TqCard, TqTable},
        data(){
            return {

                sumCreatedTickets_n : 0,
                sumCreatedCost_n : 0,
                sumStoreIncomes_byCurrency_c : {},
                showUpdateReportBtn_b : false,
                creatorTotalIncome_byUid_c : {},
                allCreatorTotalIncome_c : new FB_Cost({
                    c_currency_e : enum_costCurrency_n.DOLLAR,
                    c_value_n : 0
                }),
                notPayingUsersId_uid_b : {
                    "Jhow7yoUcXSXa2KSEaK6KSmfxgj2" : true,
                    "IylgyEl19CNLZlhznWBSZ77E3El2" : true,
                },

                outerTabs_as :['Reviews Reports', 'Monthly Payments', "User Summary"],
                outerTabs_selectedTabIndex_n: 0,

                selectedCreatorMonthlyPaymentSummary_c: 0,

                selectedMonth_yyyy_mm_s: format_date_YYYY_MM_fs((new Date()).setDate(0)),


                startMonth_yyyy_mm_s : format_date_YYYY_MM_fs((new Date()).setDate(0)),
                endMonth_yyyy_mm_s : format_date_YYYY_MM_fs((new Date()).setDate(1)),

                creatorData_byUserIds_c : {},
                selectedCreator_byUid_b : {},


                // server
                server_reportsReviews_ac : [],
                server_selectedReview_c : null,
                server_creatorMonthlyPaymentSummary_ac : [],
                server_creatorMonthlyPaymentSummary_byMonth_ac : {},



                // store
                store_system_langCode_ve : store_getStateValue_vo(store_var.system_langCode),

                // imports
                ass_strings : ass_strings,
                format_cost_s : format_cost_s,
                obj_size_fn : obj_size_fn,
                enum_creatorSendPaymentStatus : enum_creatorSendPaymentStatus,
                enum_creatorChargePaymentStatus : enum_creatorChargePaymentStatus,


            }
        },

        computed:{
            co_chartData_createdTickets_ao(){


                let currentDate_d = new Date(this.startMonth_yyyy_mm_s)
                let endDate_d = new Date(this.endMonth_yyyy_mm_s)

                let data_byUserId_ao = {}
                while(currentDate_d.getTime() <= endDate_d.getTime()) {
                    let month_mm_yyyy_s = format_date_YYYY_MM_fs(currentDate_d)
                    let server_creatorMonthlyPaymentSummary_ac = this.server_creatorMonthlyPaymentSummary_byMonth_ac[month_mm_yyyy_s]

                    if(server_creatorMonthlyPaymentSummary_ac == null){
                        continue;
                    }

                    for(let userId_uid in this.selectedCreator_byUid_b){
                        let createdTickets_n = 0
                        for(let i = 0; i<server_creatorMonthlyPaymentSummary_ac.length; i++){
                            let server_creatorMonthlyPaymentSummary_c = server_creatorMonthlyPaymentSummary_ac[i]
                            if(server_creatorMonthlyPaymentSummary_c.cmps_creatorId_uid === userId_uid){
                                createdTickets_n = server_creatorMonthlyPaymentSummary_c.cmps_createdTicketsNum_n
                                break;
                            }
                        }

                        if(!data_byUserId_ao[userId_uid]){data_byUserId_ao[userId_uid] = []}

                        data_byUserId_ao[userId_uid].push({x : month_mm_yyyy_s, y : createdTickets_n})
                    }

                    currentDate_d.setMonth(currentDate_d.getMonth()+1)
                }

                let ans_ao = []
                for(let userId_uid in this.selectedCreator_byUid_b){
                    ans_ao.push({
                        label: this.creatorData_byUserIds_c[userId_uid].ud_name_s,
                        fill: false,
                        backgroundColor: this.m_randomColor_fs(),
                        borderColor: this.m_randomColor_fs(),
                        // cubicInterpolationMode: 'monotone',
                        lineTension: 0,
                        data: data_byUserId_ao[userId_uid],
                        yAxisID: "CreatedTickets",
                    })
                }

                return ans_ao

            },
            co_chartData_storeSelle_ao(){


                let currentDate_d = new Date(this.startMonth_yyyy_mm_s)
                let endDate_d = new Date(this.endMonth_yyyy_mm_s)

                let data_byUserId_ao = []
                while(currentDate_d.getTime() <= endDate_d.getTime()) {
                    let month_mm_yyyy_s = format_date_YYYY_MM_fs(currentDate_d)
                    let server_creatorMonthlyPaymentSummary_ac = this.server_creatorMonthlyPaymentSummary_byMonth_ac[month_mm_yyyy_s]

                    if(server_creatorMonthlyPaymentSummary_ac == null){
                        continue;
                    }



                    for(let userId_uid in this.selectedCreator_byUid_b){

                        let totalStoreIncome_n = 0
                        for(let i = 0; i<server_creatorMonthlyPaymentSummary_ac.length; i++){
                            let server_creatorMonthlyPaymentSummary_c = server_creatorMonthlyPaymentSummary_ac[i]

                            if(server_creatorMonthlyPaymentSummary_c.cmps_creatorId_uid === userId_uid){

                                for(let currency_e in server_creatorMonthlyPaymentSummary_c.cmps_totalStoreIncomes_byCurrency_c){

                                    let cost_c = server_creatorMonthlyPaymentSummary_c.cmps_totalStoreIncomes_byCurrency_c[currency_e]

                                    totalStoreIncome_n+= cost_c.c_m_changeCurrency_c(enum_costCurrency_n.SHEKEL).c_value_n
                                }
                                break;
                            }
                        }

                        if(!data_byUserId_ao[userId_uid]){data_byUserId_ao[userId_uid]=[]}

                        data_byUserId_ao[userId_uid].push({x : month_mm_yyyy_s, y : totalStoreIncome_n})

                    }


                    currentDate_d.setMonth(currentDate_d.getMonth()+1)
                }


                let ans_ao = []
                for(let userId_uid in this.selectedCreator_byUid_b){
                    ans_ao.push({
                        label: this.creatorData_byUserIds_c[userId_uid].ud_name_s,
                        fill: false,
                        backgroundColor: this.m_randomColor_fs(),
                        borderColor: this.m_randomColor_fs(),
                        // cubicInterpolationMode: 'monotone',
                        lineTension: 0,
                        data: data_byUserId_ao[userId_uid],
                        yAxisID: "CreatedTickets",
                    })
                }

                return ans_ao
            },
            co_totalStoreIncome_s(){

                let ans=0
                this.co_chartData_storeSelle_ao.forEach(data_ao => {
                    data_ao.data.forEach( item => {
                        ans+= item.y
                    })
                })
                return ans.toFixed(2) + '₪'
            },
            co_totalCreatedTickets_s(){
                let ans=0

                this.co_chartData_createdTickets_ao.forEach(data_ao => {
                    data_ao.data.forEach( item => {
                        ans+= item.y
                    })
                })

                return ans
            },
            co_formatMonthSum_s(){
                if(this.selectedCreatorMonthlyPaymentSummary_c.cmps_emailBodyHtml_s){
                    return email_bodyWrapper_fs(this.selectedCreatorMonthlyPaymentSummary_c.cmps_emailBodyHtml_s)
                }
                return ''
            }
        },
        methods:{

            m_randomColor_fs(){
                const randomNum = () => Math.floor(Math.random() * (235 - 52 + 1) + 52);

                const randomRGB = () => `rgb(${randomNum()}, ${randomNum()}, ${randomNum()})`;

                return randomRGB()
            },

            m_outerTab_clickTab_f(tabIndex_n){

                this.outerTabs_selectedTabIndex_n = tabIndex_n
            },

            m_updateReviewStatus_f(reportReview_c, index){
                reportReview_c.rr_status_e = enum_reportReviewStatus_e.close
                this.server_reportsReviews_ac.splice(1,index)
                serverPre_reportReview_update_f(reportReview_c, () => {
                    notification_notify2({title_s: ass_strings.oneWord_close[this.store_system_langCode_ve.val]})
                })
            },
            m_getAllReviewsReports_f(){
                serverPre_reportReview_getOnce_f(
                    {
                        reportReview_e : enum_reportReviewStatus_e.open,
                        cb_f : (reportsReviews_byReportId_c)=> {
                            this.server_reportsReviews_ac = obj_toArray_fo(reportsReviews_byReportId_c)
                        }
                    })
            },
            m_editReview_f(reportReview_c){
                server_getUserQuestReview_fp(reportReview_c.rr_questType_e, reportReview_c.rr_questId_uid, reportReview_c.rr_reviewerUserId_uid, (review_c) => {
                    this.server_selectedReview_c = review_c
                })
            },
            m_updateReview_f(){
                server_submitQuestTqReview_f(this.server_selectedReview_c, () => {
                    notification_notify2({title_s : ass_strings.oneWord_updated[this.store_system_langCode_ve.val]})
                })
                serverPre_reportReview_getOnce_f(
                    {
                        reportReview_e : enum_reportReviewStatus_e.open,
                        cb_f : (reportsReviews_byReportId_c)=> {
                            this.server_reportsReviews_ac = obj_toArray_fo(reportsReviews_byReportId_c)
                        }
                    })
            },

            m_monthlyPayment_formatCost_20p_fs(cost_c){
                return format_cost_s(new  FB_Cost({
                    c_currency_e : cost_c.c_currency_e,
                    c_value_n : cost_c.c_value_n*25/100,
                }))
            },
            m_monthlyPayment_chargeReport_f(){
                server_admin_chargeCreatorMonthlyReport_fp(this.selectedCreatorMonthlyPaymentSummary_c).then((ans_o) =>{
                    console.log(ans_o)
                })
                this.selectedCreatorMonthlyPaymentSummary_c.cmps_chargePaymentStatus_e = enum_creatorChargePaymentStatus.charged

            },
            m_monthlyPayment_updateAllReports_f(){

                let sumMonthAndYear_d = new Date(this.selectedMonth_yyyy_mm_s)

                // let startingDate_d = new Date(sumMonthAndYear_d)
                // startingDate_d.setDate(1)
                // startingDate_d.setHours(0)
                // startingDate_d.setMinutes(0)
                // startingDate_d.setSeconds(0)
                // startingDate_d.setMilliseconds(0)
                //
                // let endingDate_d = new Date(startingDate_d)
                // endingDate_d.setMonth(startingDate_d.getMonth()+1)
                // endingDate_d.setDate(1)
                // endingDate_d.setSeconds(1)
                //
                // console.log(startingDate_d)
                // console.log(endingDate_d)

                this.showUpdateReportBtn_b = true
                server_admin_updateAllReports_fp(sumMonthAndYear_d.getTime()).then((ans) => {
                    this.showUpdateReportBtn_b = false
                })

            },
            m_monthlyPayment_updateReport_f(){

                serverBig_admin_creatorsMonthlyPaymentSummary_update_f(this.selectedCreatorMonthlyPaymentSummary_c, () => {
                    alert("updated")
                })
            },
            m_monthlyPayment_ticketsCost_fs(ticketNum_n){
                return FB_QuestTicket.qt_ms_calculateCreatorUsageCost_fn(ticketNum_n) + '$'
            },
            m_monthlyPayment_getReport_f(){

                this.server_creatorMonthlyPaymentSummary_ac = []

                serverBig_admin_creatorsMonthlyPaymentSummary_getAll_f(this.selectedMonth_yyyy_mm_s, (adminCreatorMonthlyPaymentSummary_ac)=>{

                    this.sumCreatedTickets_n = 0
                    this.sumCreatedCost_n = 0
                    this.sumStoreIncomes_byCurrency_c = {}
                    this.creatorTotalIncome_byUid_c = {}
                    this.allCreatorTotalIncome_c = new FB_Cost({
                        c_currency_e : enum_costCurrency_n.DOLLAR,
                        c_value_n : 0
                    })

                    // 1) calculate all total
                    adminCreatorMonthlyPaymentSummary_ac.forEach(creatorMonthlyPaymentSummary_c => {

                        // 1) creatorTotalIncome_byUid_c
                        let creatorTotalIncome_n = FB_QuestTicket.qt_ms_calculateCreatorUsageCost_fn(creatorMonthlyPaymentSummary_c.cmps_createdTicketsNum_n)

                        for(let currency_e in creatorMonthlyPaymentSummary_c.cmps_totalStoreIncomes_byCurrency_c){
                            let cost_c = creatorMonthlyPaymentSummary_c.cmps_totalStoreIncomes_byCurrency_c[currency_e]
                            let dollarCost_c = cost_c.c_m_changeCurrency_c(enum_costCurrency_n.DOLLAR)
                            creatorTotalIncome_n += dollarCost_c.c_value_n*25/100
                        }

                        this.creatorTotalIncome_byUid_c[creatorMonthlyPaymentSummary_c.cmps_creatorId_uid] = new FB_Cost({
                            c_currency_e : enum_costCurrency_n.DOLLAR,
                            c_value_n : creatorTotalIncome_n
                        })

                        if(!this.notPayingUsersId_uid_b[creatorMonthlyPaymentSummary_c.cmps_creatorId_uid]){

                            this.allCreatorTotalIncome_c.c_value_n += creatorTotalIncome_n

                            this.sumCreatedTickets_n += creatorMonthlyPaymentSummary_c.cmps_createdTicketsNum_n
                            this.sumCreatedCost_n += FB_QuestTicket.qt_ms_calculateCreatorUsageCost_fn(creatorMonthlyPaymentSummary_c.cmps_createdTicketsNum_n)


                            for(let currency_e in creatorMonthlyPaymentSummary_c.cmps_totalStoreIncomes_byCurrency_c){

                                if(this.sumStoreIncomes_byCurrency_c[currency_e] == null){
                                    this.sumStoreIncomes_byCurrency_c[currency_e] = new FB_Cost({c_currency_e : parseInt(currency_e), c_value_n : 0})
                                }

                                this.sumStoreIncomes_byCurrency_c[currency_e].c_value_n += creatorMonthlyPaymentSummary_c.cmps_totalStoreIncomes_byCurrency_c[currency_e].c_value_n
                            }
                        }
                    })

                    // 2) sort
                    adminCreatorMonthlyPaymentSummary_ac.sort((creatorMonthlyPaymentSummary1_c, creatorMonthlyPaymentSummary2_c) =>{
                        let totalIncome1_n = this.creatorTotalIncome_byUid_c[creatorMonthlyPaymentSummary1_c.cmps_creatorId_uid].c_value_n
                        let totalIncome2_n = this.creatorTotalIncome_byUid_c[creatorMonthlyPaymentSummary2_c.cmps_creatorId_uid].c_value_n

                        if(this.notPayingUsersId_uid_b[creatorMonthlyPaymentSummary1_c.cmps_creatorId_uid]){
                            return 1
                        }

                        if(this.notPayingUsersId_uid_b[creatorMonthlyPaymentSummary2_c.cmps_creatorId_uid]){
                            return -1
                        }

                        return totalIncome1_n > totalIncome2_n ? -1 : 1
                    })

                    // 3) update table
                    this.server_creatorMonthlyPaymentSummary_ac = adminCreatorMonthlyPaymentSummary_ac
                })
            },
            m_monthlyPayment_emailReport_f(){


                let sendEmail_c = new FB_SendEmail({
                    se_sendToEmail_s : this.selectedCreatorMonthlyPaymentSummary_c.cmps_creatorEmail_s,
                    se_title_s : this.selectedCreatorMonthlyPaymentSummary_c.cmps_emailTitle_s,
                    se_message_s : this.selectedCreatorMonthlyPaymentSummary_c.cmps_emailBodyHtml_s
                })

                server_sendMail_fp(sendEmail_c).then(() => {
                    notification_notify2({
                        title_s :  ass_strings.twoWords_sendEmail[this.store_system_langCode_ve.val],
                        text_s  : this.selectedCreatorMonthlyPaymentSummary_c.cmps_creatorEmail_s
                    })
                })

            },

            m_userReport_getReport_f(){
                this.server_creatorMonthlyPaymentSummary_byMonth_ac = []

                let currentDate_d = new Date(this.startMonth_yyyy_mm_s)
                let endDate_d = new Date(this.endMonth_yyyy_mm_s)
                console.log("m_userReport_getReport_f")

                while(currentDate_d.getTime() <= endDate_d.getTime()){
                    let month_mm_yyyy_s = format_date_YYYY_MM_fs(currentDate_d)

                    serverBig_admin_creatorsMonthlyPaymentSummary_getAll_f(month_mm_yyyy_s, (creatorMonthlyPaymentSummary_ac)=>{

                        creatorMonthlyPaymentSummary_ac.forEach(creatorMonthlyPaymentSummary_c => {

                            if(this.creatorData_byUserIds_c[creatorMonthlyPaymentSummary_c.cmps_creatorId_uid] === undefined){
                                this.$set(this.creatorData_byUserIds_c, creatorMonthlyPaymentSummary_c.cmps_creatorId_uid, null)

                                serverAuth_getOtherUserData_f(creatorMonthlyPaymentSummary_c.cmps_creatorId_uid, (userData_c) => {
                                    this.creatorData_byUserIds_c[creatorMonthlyPaymentSummary_c.cmps_creatorId_uid] = userData_c


                                })
                            }
                        })

                        this.$set(this.server_creatorMonthlyPaymentSummary_byMonth_ac, month_mm_yyyy_s, creatorMonthlyPaymentSummary_ac)
                    })
                    currentDate_d.setMonth(currentDate_d.getMonth()+1)

                }



            },

        },

    }
</script>

<style scoped lang="scss">
table{
    background: white;
    border-collapse: collapse;
    display: inline-block;


    td, th{
        border: 2px solid black;
        padding: 4px;
    }

    td {
        text-transform: none;
    }

    th{
        background: gainsboro;
    }
}


</style>